import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatLocaleNumber } from '../utils/formatLocaleNumber';

export const usePerformanceAudienceFormatters = () => {
  const { i18n } = useTranslation('performanceAudience');

  const formatNumber = useCallback(
    (value: number) => formatLocaleNumber(value, i18n.language),
    [i18n.language]
  );

  return { formatNumber };
};
